import styled from 'styled-components';
import colors, { opacity } from 'styles/colors';
import DropdownMenu from 'components/DropdownMenu';
import { fontWeight } from 'styles/common';

export const StyledDropdownMenu = styled(DropdownMenu)`
  button {
    position: inherit;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-bottom: 6px;
  width: fit-content;
`;

export const ListFilters = styled.div`
  display: flex;
  padding: 4px 16px 0 16px;
  gap: 8px;
  background-color: ${colors.white};
  height: 44px;
`;

export const ResultCount = styled.div`
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  padding: 0 6px;
  border: 1px solid ${colors.fleetOffGray};
  border-radius: 3px;
`;

export const FilterTab = styled.div<{ $selected: boolean }>`
  font-size: 14px;
  font-weight: ${fontWeight.semibold};
  line-height: 22px;
  text-align: center;

  &[disabled] {
    color: ${colors.disabledButtonText};
    cursor: not-allowed;

    & ${ResultCount} {
      background-color: ${colors.disabledButtonBackground};
    }
  }
  & > div {
    padding: 3px;
  }

  &:not([disabled]) {
    ${({ $selected }) => `color: ${$selected ? colors.blue : colors.primary};`}

    & ${ResultCount} {
      ${({ $selected }) => `background-color: ${$selected ? colors.fleetBlue : opacity(colors.fleetOffGray, 0.4)};`}
      ${({ $selected }) => `color: ${$selected ? colors.white : colors.primary};`}
    }

    &:hover > div {
      border-radius: 3px;
      background-color: ${opacity(colors.fleetOffGray, 0.4)};
    }
  }

  ${({ $selected }) => `border-bottom: 4px solid ${$selected ? colors.blue : colors.white};`}
`;

export const OuterTableHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const TabLabel = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;
